import { useEffect, useState } from 'react';

import useRequest from '@swf/core/hooks/useRequest';
import type {
  ClubRecentTournamentSummary,
  GetRecentTournamentsPlayerResultsResponse,
  HgRecentTournResultsReply
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse } from '@swf/poker';

import useGetRecentTournamentsSummaries from './useGetRecentTournamentsSummaries';

const useGetRecentTournamentsPlayerResults = (clubId: number) => {
  const request = useRequest();
  const [resultsLoading, setResultsLoading] = useState(true);
  const [results, setResults] = useState<HgRecentTournResultsReply>();
  const {
    recentTournaments: { summaries },
    loading
  } = useGetRecentTournamentsSummaries(clubId);

  useEffect(() => {
    if (!summaries?.length) {
      setResultsLoading(false);
      return;
    }

    const { tournId } = summaries[summaries?.length - 1];

    request({
      service: 'homeGames.getRecentTournamentsPlayerResultsRequest',
      body: { tournId }
    }).subscribe(({ body }) => {
      const { error, data } = handleServerResponse<
        GetRecentTournamentsPlayerResultsResponse,
        HgRecentTournResultsReply['playerResults']
      >({
        response: body,
        accessor: 'recentTournResultsReply'
      });

      if (!error) {
        setResults(data);
      }
      setResultsLoading(false);
    });
  }, [request, summaries, loading]);

  return {
    results: results?.playerResults,
    resultsLoading: loading || resultsLoading,
    summary:
      summaries?.length &&
      (summaries[summaries?.length - 1] as Required<ClubRecentTournamentSummary>)
  };
};

export default useGetRecentTournamentsPlayerResults;
